import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Reloads the calculated functionalizations when the collection context changes,
 * so the Lab Service's Auto Lab Based allocations reflect the newly viewed
 * record. Parameter resolution lives in {@link loadForCurrentEntity}.
 */
export const loadOnContextChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('(effect) load on context change')
            .create(),
        ),
      ),
)
